export const enUS = {
    components: {
        generic: {
            input_search_label: 'Search',
            title_card_label: 'Create a new group',
            select_group_label: 'Select a group',
            input_name_group_label: 'Name of group',
            input_name_label: 'Name',
            input_email_label: 'E-mail',
            input__current_password_label: 'Current password',
            input_password_label: 'Password',
            input_confirm_password_label: 'Confirm Password', 
            select_country_lang_label: 'Select the language',
            input_user_label:'User Name',
            input_enterprise:'Enterprise name',
            input_host: "Host",
            input_database: "Database",
            input_schema: "Schema"
        }
    }
}